module.exports = __webpack_public_path__ + "img/76800.e70ced43.jpg";